module.exports = __webpack_public_path__ + "static/media/wildlife.88227a9a.jpg";